import { render } from "./TheHeader.vue?vue&type=template&id=f109b52e&scoped=true&bindings={\"theme\":\"props\",\"showMenu\":\"data\",\"image\":\"options\",\"heart\":\"options\",\"menu\":\"options\",\"favouritesTotal\":\"options\",\"handleMenu\":\"options\"}"
import script from "./TheHeader.vue?vue&type=script&lang=js"
export * from "./TheHeader.vue?vue&type=script&lang=js"

import "./TheHeader.vue?vue&type=style&index=0&id=f109b52e&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-f109b52e"

export default script